import { useTranslation } from 'react-i18next';
import { Container } from 'semantic-ui-react';

const Forbidden403 = () => {

    const { t } = useTranslation();

    return (
        <Container className="page systempage">
            <h1>403</h1>
            <p>{t('pages.forbidden')}</p>
        </Container>
    );
}

export default Forbidden403;